import React, { useState } from "react";
import { Play, ArrowDownCircle, X } from "lucide-react";
import { welcome, company } from "../mock";

const PROMO_EMBED = "https://www.youtube.com/embed?listType=search&list=wood%20burning%20stove%20installation";

const Welcome = () => {
  const [open, setOpen] = useState(false);
  const go = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="about" className="bg-white py-10 px-4 md:px-10" data-testid="welcome-section">
      <div className="max-w-[1140px] mx-auto grid lg:grid-cols-2 gap-8 items-center">
        <div className="fade-up text-center">
          <h2 className="text-charcoal font-medium text-[19px] md:text-[28px]">{welcome.heading}</h2>
          <div className="py-1">
            <span className="block mx-auto w-[30%] h-[1.1px] bg-fire" />
          </div>
          <p className="text-charcoal text-[16px] leading-relaxed mt-2">{welcome.intro}</p>
          <p className="text-charcoal text-[16px] leading-relaxed mt-4">{welcome.body}</p>
          <button
            onClick={() => go("#quote")}
            className="btn-fire inline-flex items-center gap-2 mt-6 px-6 py-3 text-[15px] md:text-[17px]"
            data-testid="welcome-quote-button"
          >
            <ArrowDownCircle size={18} /> Get A Free Quote
          </button>
        </div>

        <div className="fade-up">
          <button
            onClick={() => setOpen(true)}
            className="group relative w-full aspect-video overflow-hidden bg-black"
            aria-label="Play promotional video"
            data-testid="welcome-video-button"
          >
            <img src={company.heroImg} alt="Stove Scotland TV advert" className="w-full h-full object-cover opacity-80" />
            <span className="absolute inset-0 flex items-center justify-center">
              <span className="w-16 h-16 rounded-full bg-fire flex items-center justify-center shadow-lg transition-transform group-hover:scale-110">
                <Play className="text-white ml-1" size={28} fill="white" />
              </span>
            </span>
          </button>
        </div>
      </div>

      {open && (
        <div className="fixed inset-0 z-[70] flex items-center justify-center p-4">
          <div className="absolute inset-0 bg-black/80" onClick={() => setOpen(false)} />
          <div className="relative w-full max-w-4xl aspect-video">
            <button onClick={() => setOpen(false)} className="absolute -top-11 right-0 text-white/80 hover:text-white" aria-label="Close" data-testid="video-close-button">
              <X size={28} />
            </button>
            <iframe
              className="w-full h-full"
              src={PROMO_EMBED}
              title="Stove Scotland video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      )}
    </section>
  );
};

export default Welcome;
